import React, { useState } from 'react';
import { MenuItem, Select, ListItemIcon } from '@mui/material';
import { useTranslation } from 'react-i18next';

const LocalizationDropdown = ({ handleLanguageChange,language }) => {
    const { t } = useTranslation()
    return (
        <Select
            value={language}
            onChange={handleLanguageChange}
            sx={{
                width: 150,
                height: 35,
            }}
            renderValue={(selected) => (
                <span style={{ display: 'flex', alignItems: 'center' }}>
                    {selected === 'fr' ? t("Français") : t("Anglais")}
                </span>
            )}
        >
            <MenuItem value="fr">
                {t("Français")}
            </MenuItem>
            <MenuItem value="en">
                {t("Anglais")}
            </MenuItem>
        </Select>
    );
};

export default LocalizationDropdown;
